var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53906 0.385742L10.3323 1.45091C10.5989 1.51041 10.7891 1.74666 10.7891 2.02024V7.84599C10.7891 9.01616 10.204 10.1093 9.2304 10.758L5.53906 13.2191L1.84773 10.758C0.873562 10.1087 0.289062 9.01616 0.289062 7.84658V2.02024C0.289062 1.74666 0.479229 1.51041 0.745812 1.45091L5.53906 0.385742ZM5.53906 1.58099L1.45573 2.48808V7.84599C1.45573 8.62591 1.8454 9.35449 2.49465 9.78733L5.53906 11.8173L8.58348 9.78733C9.23273 9.35449 9.6224 8.62649 9.6224 7.84658V2.48808L5.53906 1.58158V1.58099ZM8.13606 4.59858L8.96148 5.42341L5.24915 9.13574L2.77406 6.66066L3.5989 5.83583L5.24856 7.48549L8.13606 4.59799V4.59858Z",
    fill: "url(#paint0_linear_14118_68007)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14118_68007",
    x1: 5.53906,
    y1: 0.385742,
    x2: 5.53906,
    y2: 13.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3AA64C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34E36F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuard);
export default __webpack_public_path__ + "static/media/guard.e3762a0865fcbc220320a9b946a061e5.svg";
export { ForwardRef as ReactComponent };